import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-451948a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center" }
const _hoisted_7 = { class: "mb-2 text-center" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_10 = { class: "slider-wrapper flex-1" }
const _hoisted_11 = { class: "slider-annotation" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "w-75 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ProductConfigurationStep = _resolveComponent("ProductConfigurationStep")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_ProductConfiguration = _resolveComponent("ProductConfiguration")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductLayoutSimple = _resolveComponent("ProductLayoutSimple")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductLayoutSimple, null, {
      header: _withCtx(() => [
        _renderSlot(_ctx.$slots, "breadcrumbs", {}, undefined, true),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.vm.introTitle)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.vm.introTitle), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.vm.intro), 1)
        ])
      ]),
      configuration: _withCtx(() => [
        _createVNode(_component_ProductConfiguration, { class: "mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductConfigurationStep, { id: "step-walletType" }, {
              error: _withCtx(() => [
                (
								!_ctx.walletProductValidation.get(_ctx.WalletProductValidationEnum.AtleastOneTypeSelected) &&
								_ctx.submitted
							)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      id: `validation-msg-${_ctx.WalletProductValidationEnum.AtleastOneTypeSelected}`,
                      closable: false,
                      severity: "error"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneWalletType")), 1)
                      ]),
                      _: 1
                    }, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]),
              header: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("product.lblChooseWalletType")), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depositTypeOptions, (option, index) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: `walletDepositType_${index}`,
                      class: _normalizeClass(["col product-configuration-option-card", { 'p-highlight': option.isSelected, 'p-disabled': _ctx.isOptionDisabled(option) }]),
                      onClick: ($event: any) => (option.isSelected = !option.isSelected)
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_font_awesome_icon, {
                            class: "mb-2",
                            icon: option.icon,
                            size: "2x"
                          }, null, 8, ["icon"]),
                          _createElementVNode("b", _hoisted_7, _toDisplayString(option.label), 1),
                          _createVNode(_component_Checkbox, {
                            modelValue: option.isSelected,
                            "onUpdate:modelValue": ($event: any) => ((option.isSelected) = $event),
                            binary: true,
                            class: "mt-auto",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ProductConfigurationStep, { id: "step-walletAmount" }, {
              header: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("product.lblChooseWalletAmount")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Card, null, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_Slider, {
                          modelValue: _ctx.price,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.price) = $event)),
                          disabled: _ctx.isBusy,
                          max: _ctx.maxPrice,
                          min: _ctx.minPrice,
                          step: _ctx.minPrice,
                          onChange: _ctx.onPriceChange
                        }, null, 8, ["modelValue", "disabled", "max", "min", "step", "onChange"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("small", null, _toDisplayString(_ctx.formatCurrency(_ctx.minPrice)), 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.currentPrice)), 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.formatCurrency(_ctx.maxPrice)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Button, {
            class: "p-button-success p-button-lg p-button-raised p-button-arrow w-100 px-1 mb-1",
            disabled: _ctx.isBusy || (_ctx.submitted && !_ctx.validateProductConfiguration()),
            label: _ctx.$t(`common.addToCart`),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToCart()))
          }, null, 8, ["disabled", "label"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("product.walletDepositDisclaimer")), 1)
        ])
      ]),
      _: 3
    }),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 0,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}